import { render } from "./NewDistributorInvoiceView.vue?vue&type=template&id=baad99a2"
import script from "./NewDistributorInvoiceView.vue?vue&type=script&lang=js"
export * from "./NewDistributorInvoiceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__